
var id = "preview";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"preview\">\n<path d=\"M92.3,67.8c14.9,0,26.9,12.1,26.9,26.9c0,5.8-1.9,11.4-5.3,16l8.3,8.3c2,2.1,2,5.4-0.1,7.4c-2,2-5.3,2-7.3,0l-8.7-8.7\n\tc-12.7,7.7-29.3,3.6-37-9.2s-3.6-29.3,9.2-37C82.6,69.2,87.4,67.8,92.3,67.8z M100.9,0c8.5,0,15.8,6.3,17.1,14.7l0.2,1.4l0.1,1.3\n\tv35.8c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2V17.6l0-0.9c-0.3-3.2-2.8-5.8-6-6.3l-0.9-0.1H21.1l-0.9,0\n\tc-3.2,0.3-5.8,2.8-6.2,6L14,17.4v88.4l0,0.9c0.3,3.2,2.8,5.8,6,6.3l0.9,0.1h31.2c2.9,0,5.2,2.3,5.2,5.2c0,2.6-1.8,4.7-4.4,5.1\n\tl-0.9,0.1H20.8c-8.5,0-15.8-6.3-17.1-14.7l-0.2-1.4L3.6,106V17.4c0-8.5,6.2-15.8,14.6-17.2l1.3-0.2L20.8,0C20.8,0,100.9,0,100.9,0z\n\t M92.3,78.2c-9.1,0-16.5,7.4-16.5,16.5s7.4,16.5,16.5,16.5s16.5-7.4,16.5-16.5S101.4,78.2,92.3,78.2z M50.2,65c2.7,0,5,2.3,5,5.1\n\tc0,2.5-1.8,4.6-4.1,5l-0.8,0.1H37.9c-2.8,0-5-2.3-5-5.1c0-2.5,1.8-4.6,4.2-5l0.8-0.1H50.2L50.2,65z M77.4,35.2c2.7,0,5,2.3,5,5.1\n\tc0,2.5-1.8,4.6-4.2,5l-0.8,0.1H37.9c-2.8,0-5-2.3-5-5.1c0-2.5,1.8-4.6,4.2-5l0.8-0.1H77.4z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
